import React, { useState, useEffect } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row, Button, Form, InputGroup } from 'react-bootstrap'
import Image from '@components/Image'
import ReCAPTCHA from 'react-google-recaptcha'
import toast, { Toaster } from 'react-hot-toast'
import { useSendContactFormMutation } from '@apis/originalTokkoApi/contact'
import { ElementHTML } from '@helpers/helper.rendering'

type CombinedProps = RealEstateDataPageComponentData

const Newsletter1 = (props: CombinedProps) => {
  const {
    image_gatsby,
    subtitle,
    title,
    paragraph,
    button,
    global_data,
    titleColor,
    titleElement,
    titleHexa,
  } = props

  const { captcha, tokko: API_KEY } = global_data.pageConfig.keys
  const realEstateName = global_data.name

  const [disabled, setDisabled] = useState(true)
  const [datos, setDatos] = useState({
    email: '',
  })

  const [token, setValueToken] = useState('')

  function onChange(value: any) {
    setValueToken(value)
  }

  const [sendContactForm] = useSendContactFormMutation()

  useEffect(() => {
    if (!captcha) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [])

  const handleInputChange = (event: any) => {
    setDatos({
      ...datos,
      [event.target.name]: event.target.value,
    })
  }

  const sendForm = (event: any) => {
    event.preventDefault()
    var tags = [...getUtm(), 'Nuevo suscriptor', realEstateName]

    const { email } = datos

    const body = JSON.stringify({ email, tags })

    if (API_KEY) sendContactForm({ API_KEY: API_KEY, body: body })
    else sendContactForm({ data: datos, type: 'newsletter', site: global_data.id })
    ;(document?.getElementById('formNewsletter') as HTMLFormElement)?.reset()
    return toast.success('¡Se ha suscripto correctamente!')
  }

  const getUtm = () => {
    if (typeof window !== 'undefined') {
      var queryString = window.location.search
      var urlParams = new URLSearchParams(queryString)
      const tags = []
      for (const [key, value] of urlParams) {
        if (key.includes('source')) {
          tags.push('Origen: ' + value)
        }
        if (key.includes('medium')) {
          tags.push('Pieza: ' + value)
        }
        if (key.includes('campaign')) {
          tags.push('Campaña: ' + value)
        }
      }
      return tags
    }
    return []
  }

  console.log(titleElement)

  return (
    <section className="newsletter a">
      <Container fluid>
        <Row className={image_gatsby ? '' : 'justify-content-center'}>
          <Col
            xs={12}
            lg={image_gatsby ? 6 : 5}
            className={'ps-lg-5 d-flex align-items-start justify-content-center flex-column '}
          >
            <div
              className={
                'd-flex flex-column contenedor mx-auto mx-lg-0 align-items-center align-items-lg-start justify-content-center '
              }
            >
              <h4
                className={
                  'subtitle text-uppercase mb-3 ' + (image_gatsby ? '' : ' mx-auto text-center')
                }
              >
                {subtitle}
              </h4>
              <ElementHTML
                className={
                  'title my-4 ' +
                  (image_gatsby ? '' : ' mx-auto text-center') +
                  (titleHexa ? ' ' + titleHexa : '')
                }
                style={{ color: titleColor }}
                elementType={titleElement || 'h2'}
                children={title || ''}
              />

              {/* <h2 className={'title my-4 ' + (image_gatsby ? '' : ' mx-auto text-center')}>
                {title}
              </h2> */}
              {paragraph ? (
                <p
                  className={
                    'text-content mt-2 mb-4 ' +
                    (image_gatsby ? ' text-center text-lg-start ' : 'text-center mx-auto ')
                  }
                >
                  {paragraph}
                </p>
              ) : null}
              <Form
                id="formNewsletter"
                onSubmit={sendForm}
                className="w-100"
              >
                {/* <Toaster
                  toastOptions={{
                    className: 'toast-className',
                    style: {
                      maxWidth: 'fit-content',
                    },
                  }}
                /> */}
                <InputGroup className="mt-3">
                  <Form.Control
                    required
                    type="email"
                    name="email"
                    id="emailInpt"
                    className="me-2"
                    autoComplete="off"
                    onChange={handleInputChange}
                    placeholder="Ingresa tu e-mail*"
                    aria-label="Ingresa tu e-mail*"
                  />
                  <Button
                    type="submit"
                    id="submitBtn"
                    disabled={disabled}
                    className={
                      'ms-2 btn btn-primary submit fst-italic' + (button?.border ? ' border ' : '')
                    }
                  >
                    {button?.value}
                  </Button>
                  <Col
                    xs={12}
                    className="d-flex flex-column"
                  >
                    <p className="mt-2 mb-4 ms-2 required-text fst-italic">*Campo obligatorio.</p>
                    {captcha ? (
                      <ReCAPTCHA
                        sitekey={captcha}
                        className="captcha-wrapper"
                        onChange={(value) => {
                          setDisabled(false)
                          onChange(value)
                        }}
                      />
                    ) : null}
                  </Col>
                </InputGroup>
              </Form>
            </div>
          </Col>
          {image_gatsby && (
            <Col
              xs={12}
              lg={{ span: 4, offset: 2 }}
              xl={{ span: 4, offset: 2 }}
              className="d-none d-lg-flex justify-content-center align-items-end mt-lg-0 py-lg-0 pt-5 mt-5"
            >
              <Image
                objectFit="cover"
                alt="newsletter-img"
                image={image_gatsby!}
                className="w-100 mt-auto mb-0 no-border py-lg-0 newsletter-img"
              />
            </Col>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default Newsletter1
